var map = {
	"./star1.webp": "3b24",
	"./star1_sm.webp": "35bc",
	"./star2.webp": "845d",
	"./star2_sm.webp": "595e",
	"./star3.webp": "5c87",
	"./star3_sm.webp": "7356",
	"./star4.webp": "8571",
	"./star4_sm.webp": "f2b1",
	"./stars.webp": "c7c1",
	"./stars_sm.webp": "afed"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e727";